import React, { FC } from 'react'

import { appConfig } from 'Config'

export const DebugPanel: FC = ({ children }) => {
  return appConfig.showDebugInfo ? <div className="debug my-1">{children}</div> : null
}
